const BouncingDotsLoader = () => {
  return (
    <>
      <div className="bouncing-loader" style={{ marginTop: "54px" }}>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </>
  );
};

export default BouncingDotsLoader;
